



import Vue from "vue";
import data from "@/datatables/accounts/monthly-report";
import datatable from "@/utils/datatable/components/datatable.vue";
export default Vue.extend({
  name: "supplier-balance",
  components:{
    datatable
  },
  data(){
    return {
        data
    }
  },
});
